import {
  CasinoGameTagDialogData,
  ConfirmationDialogData,
  DocumentUploadDialogData,
  InformativeDialogData,
  SystemBetSelectionOverviewDialogData,
  SystemBetStakeUpdateDialogData,
} from '../../data-types/dialogs/dialogInterfaces';
import { NonUkUserVerificationDialogData } from '../../data-types/international/internationalInterfaces';
import { GhostUserDialogData } from '../../data-types/login/loginInterfaces';
import { QueuedDialog, QueuedNotification } from '../../data-types/notification/notificationInterfaces';
import { store } from '../store';
import {
  DECREASE_LIMIT_CONFIRMATION_DIALOG_COUNT,
  DEQUEUE_ALL_SYSTEM_BET_STAKE_UPDATE_DATA,
  DEQUEUE_DIALOG,
  DEQUEUE_NOTIFICATION,
  DEQUEUE_SYSTEM_BET_STAKE_UPDATE_DATA,
  ENQUEUE_DIALOG,
  ENQUEUE_NOTIFICATION,
  INCREASE_LIMIT_CONFIRMATION_DIALOG_COUNT,
  SET_CASINO_GAME_TAG_DIALOG_DATA,
  SET_CHAT_COOKIE_DIALOG,
  SET_CONFIRMATION_DIALOG_DATA,
  SET_COOKIE_SNACKBAR,
  SET_DISPLAY_APP_INSTALL_PROMPT,
  SET_DOCUMENT_UPLOAD_DATA,
  SET_ERROR_DIALOG,
  SET_INFORMATIVE_DIALOG_DATA,
  SET_IS_INBOX_OPEN,
  SET_MY_PROMOTIONS_DIALOG_OPEN,
  SET_NET_PROMOTER_SCORE_DIALOG,
  SET_NON_UK_USER_VERIFICATION_DIALOG,
  SET_POST_HOG_SURVEY_DIALOG,
  SET_REALITY_CHECK_DIALOG,
  SET_REVIEW_DIALOG_OPEN,
  SET_SYSTEM_BET_STAKE_UPDATE_DIALOG_DATA,
  SET_SYSTEM_BETS_OVERVIEW_DIALOG_DATA,
  SET_USER_CONFIRM_PRODUCT_UNBLOCK_DIALOG,
  TOGGLE_GHOST_USER_DIALOG,
} from '../types/dialogTypes';

export const setErrorDialog = (error: string) => {
  store.dispatch({
    type: SET_ERROR_DIALOG,
    meta: error,
  });
};

export const enqueueDialog = (meta: QueuedDialog) => {
  store.dispatch({
    meta,
    type: ENQUEUE_DIALOG,
  });
};

export const dequeueDialog = () => {
  store.dispatch({
    type: DEQUEUE_DIALOG,
  });
};

export const enqueueNotification = (meta: QueuedNotification) => {
  store.dispatch({
    meta,
    type: ENQUEUE_NOTIFICATION,
  });
};

export const dequeueNotification = () => {
  store.dispatch({
    type: DEQUEUE_NOTIFICATION,
  });
};

export const toggleGhostUserDialog = (data: GhostUserDialogData) => {
  store.dispatch({
    type: TOGGLE_GHOST_USER_DIALOG,
    meta: { ...data, open: !store.getState().dialogs.ghostUserDialogData.open },
  });
};

export const setCookieSnackbar = (open: boolean) => {
  store.dispatch({
    type: SET_COOKIE_SNACKBAR,
    meta: open,
  });
};

export const setChatCookieDialog = (open: boolean) => {
  store.dispatch({
    type: SET_CHAT_COOKIE_DIALOG,
    meta: open,
  });
};

export const setRealityCheckDialog = (open: boolean) => {
  store.dispatch({
    type: SET_REALITY_CHECK_DIALOG,
    meta: open,
  });
};

export const setNonUkUserVerificationDialog = (meta: NonUkUserVerificationDialogData) => {
  store.dispatch({
    meta,
    type: SET_NON_UK_USER_VERIFICATION_DIALOG,
  });
};

export const setReviewDialogOpen = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_REVIEW_DIALOG_OPEN,
  });
};

export const setDisplayAppInstallPrompt = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_DISPLAY_APP_INSTALL_PROMPT,
  });
};

export const setUserConfirmProductUnblockDialog = (open: boolean) => {
  store.dispatch({
    type: SET_USER_CONFIRM_PRODUCT_UNBLOCK_DIALOG,
    meta: open,
  });
};

export const increaseLimitConfirmationDialogCount = () => {
  store.dispatch({
    type: INCREASE_LIMIT_CONFIRMATION_DIALOG_COUNT,
  });
};

export const decreaseLimitConfirmationDialogCount = () => {
  store.dispatch({
    type: DECREASE_LIMIT_CONFIRMATION_DIALOG_COUNT,
  });
};

export const setConfirmationDialogData = (meta: ConfirmationDialogData) => {
  store.dispatch({
    meta,
    type: SET_CONFIRMATION_DIALOG_DATA,
  });
};

export const setNetPromoterScoreDialog = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_NET_PROMOTER_SCORE_DIALOG,
  });
};

export const setIsInboxOpen = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_IS_INBOX_OPEN,
  });
};

export const setDocumentUploadData = (meta: DocumentUploadDialogData) => {
  store.dispatch({
    meta,
    type: SET_DOCUMENT_UPLOAD_DATA,
  });
};

export const setInformativeDialogData = (meta: InformativeDialogData) => {
  store.dispatch({
    meta,
    type: SET_INFORMATIVE_DIALOG_DATA,
  });
};

export const setCasinoGameTagDialogData = (meta: CasinoGameTagDialogData) => {
  store.dispatch({
    meta,
    type: SET_CASINO_GAME_TAG_DIALOG_DATA,
  });
};

export const setSyStemBetStakeUpdateDialogData = (meta: SystemBetStakeUpdateDialogData) => {
  store.dispatch({
    meta,
    type: SET_SYSTEM_BET_STAKE_UPDATE_DIALOG_DATA,
  });
};

export const dequeueSystemBetStakeUpdateDialogData = () => {
  store.dispatch({
    type: DEQUEUE_SYSTEM_BET_STAKE_UPDATE_DATA,
  });
};

export const setSystemBetSelectionOverviewDialogData = (meta: SystemBetSelectionOverviewDialogData) => {
  store.dispatch({
    meta,
    type: SET_SYSTEM_BETS_OVERVIEW_DIALOG_DATA,
  });
};

export const setPostHogSurveyDialogOpen = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_POST_HOG_SURVEY_DIALOG,
  });
};

export const setMyPromotionsDialogOpen = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_MY_PROMOTIONS_DIALOG_OPEN,
  });
};

export const dequeueAllSystemBetStakeUpdateDialogData = () => {
  store.dispatch({
    type: DEQUEUE_ALL_SYSTEM_BET_STAKE_UPDATE_DATA,
  });
};
